module.exports = __webpack_public_path__ + "img/shopify.56481801.svg";